import {
  BrowserHistory,
  MemoryHistory,
  createBrowserHistory,
  createMemoryHistory
} from "history"

import { isNode, isWeb } from "./runtimeEnvironment"

let browserHistory: BrowserHistory | MemoryHistory | undefined

export function history(): BrowserHistory {
  if (!browserHistory) {
    if (isWeb()) {
      browserHistory = createBrowserHistory()
    } else if (isNode()) {
      browserHistory = createMemoryHistory()
    }
  }

  return browserHistory as unknown as BrowserHistory
}
